import { createContext, useContext } from 'use-context-selector';

export const ObsStoreContext = createContext<{
  enableAuditTime?: boolean;
}>({ enableAuditTime: true });

export const useObsStoreContext = () => {
  return useContext(ObsStoreContext);
};
